<div class="flex flex-col justify-center items-center">
  <div
    [innerHTML]="loadingSVG"
    class="mb-4"
  ></div>
  @if (title()) {
    <div
      [class.text-white]="white()"
      class="text-sm font-bold"
    >
      {{ title() }}
    </div>
  }
</div>
